import { SidebarLink } from 'types/sidebar'
import { PageAccess } from 'types/user'
import { SIDEBAR_LINKS } from 'utils/constants'
import { checkPageAccess } from './authorization'

export const generateSidebarLinks = (permissionsList: PageAccess[]) => {
  if (!permissionsList || permissionsList?.length <= 0) return []

  const validLinks: SidebarLink[] = []

  SIDEBAR_LINKS.forEach((page) => {
    const hasPermissionForParent = checkPageAccess(page.id, permissionsList)

    // checking permissions for `parent` links which dont have child link
    if (hasPermissionForParent.page) validLinks.push(page)
    // checking permissions for `child` links
    else if (page.children && page.children.length > 0) {
      // checking whether sub links have access
      // filtering all sub links
      const validChildPages = page.children?.filter((subPage) => {
        const childPermission = checkPageAccess(subPage.id, permissionsList)

        return childPermission.page ? true : false
      })

      if (validChildPages && validChildPages.length > 0) {
        validLinks.push({ ...page, children: validChildPages })
      }
    }
  })

  return validLinks
}
